import pick from 'lodash/pick';
var noop = function () { };
export var LINEAR = function (from, to, passed, duration) {
    return from + (to - from) * (Math.min(passed, duration) / duration);
};
export var requestAnimationFramePolyFill = function (step) {
    setTimeout(function () {
        step(Date.now());
    }, 1000 / 60);
};
export var requestAnimationFrame = function (step) {
    var func = requestAnimationFramePolyFill;
    if (window === null || window === void 0 ? void 0 : window.requestAnimationFrame) {
        func = window.requestAnimationFrame;
    }
    func(step);
};
export var transition = function (element, endValues, func, duration, done) {
    if (done === void 0) { done = noop; }
    var startValues = pick(element, Object.keys(endValues));
    var start;
    function step(timestamp) {
        if (!start) {
            start = timestamp;
        }
        Object.keys(endValues).forEach(function (key) {
            var to = startValues[key];
            if (to !== undefined && typeof to === 'number') {
                element[key] = func(to, endValues[key], timestamp - start, duration);
            }
        });
        if (timestamp - start < duration) {
            requestAnimationFrame(step);
        }
        else {
            done();
        }
    }
    requestAnimationFrame(step);
};
